;(function() {
  'use strict'

  controller.$inject = ["$scope", "$stateParams", "glDialog", "glError", "facesService", "messageService", "Message", "imageService"];
  angular.module('app.messageDetail').controller('MessageDetail', controller)

  /* @ngInject */
  function controller(
    $scope,
    $stateParams,
    glDialog,
    glError,
    facesService,
    messageService,
    Message,
    imageService
  ) {
    var message

    $scope.States = {
      LOADING: 'loading',
      ERROR: 'error',
      READY: 'ready',
    }
    $scope.data = {}
    $scope.Message = Message
    $scope.addComment = addComment
    $scope.close = messageService.close
    $scope.flag = messageService.flag
    $scope.flagComment = messageService.flagComment
    $scope.share = messageService.share
    $scope.moods = facesService.get()
    $scope.moodClass = moodClass
    $scope.titlePrefix = titlePrefix

    var titlePrefixes = {
      question: 'Question for ',
      feedback: 'Feedback to ',
      idea: 'Idea for ',
      complaint: 'Complaint to ',
      praise: 'Praise for ',
      suggestion: 'Suggestion for ',
      request: 'Request for ',
    }

    init()

    function init() {
      var token = $stateParams.token || $stateParams.accessToken

      $scope.state = $scope.States.LOADING

      // get message and mark as read after 3 seconds
      messageService.getById($stateParams.id, token, 3000).then(function(msg) {
        $scope.message = message = msg

        checkAndCloseWithMood(function(mood) {
          var didClose = _.isNumber(mood)
          $scope.state = $scope.States.READY

          if (didClose) {
            showClosedDialog(mood)
          }
        })
      }, glError.fromStatus)
    }

    function checkAndCloseWithMood(done) {
      if ($stateParams.closeMood && !message.isClosed()) {
        var closeMood = _.parseInt($stateParams.closeMood)
        message.close(closeMood).then(
          function() {
            done(closeMood)
          },
          function() {
            done()
          }
        )
      } else {
        done()
      }
    }

    function showClosedDialog(mood) {
      glDialog.show({
        templateUrl: 'message-closed-dialog.template.html',
        controller: 'MessageClosedDialog',
        locals: {
          closeMood: mood,
        },
      })
    }

    function addComment() {
      var comment = $scope.data.comment
      var imageData = $scope.data.imageData
      delete $scope.data.comment
      delete $scope.data.imageData

      if (imageData) {
        // Append markdown to message body and send
        $scope.isSending = true
        imageService.upload(imageData).then(function(imageUrl) {
          var imageMarkdown = '![](' + imageUrl + ')'
          var text = (comment ? comment + '\n' : '') + imageMarkdown
          send(text)
        }, sendError)
      } else {
        send(comment)
      }

      function send(text) {
        return message.addComment(text).then(function success() {
          $scope.isSending = false
        }, sendError)
      }

      function sendError() {
        var title = 'Comment Error'
        var msg =
          'There was an issue sending your comment. Please refresh the page and try again'

        glDialog.alert(title, msg)

        // put text back into input
        $scope.data.comment = comment
        $scope.data.imageData = imageData
        $scope.isSending = false
      }
    }

    function moodClass(message) {
      var mood =
        message.moodCurrent &&
        _.find($scope.moods, { value: message.moodCurrent })
      if (mood) {
        return '-visible ' + mood.iconClass
      }
    }

    function titlePrefix(message) {
      return titlePrefixes[message.type]
    }
  }
})()
